export const getSendProspectToAPIInfo = state => state.sendProspectToAPI || {};

export const getIsSendingProspect = state => getSendProspectToAPIInfo(state).loading;

export const getScreeningError = state => getSendProspectToAPIInfo(state).screeningError;

export const getLastProspectSaved = state => getSendProspectToAPIInfo(state).lastProspect;

export const getLastRoProspectSaved = state => getSendProspectToAPIInfo(state).lastRoProspect;

export const getLastProspectTime = state => getSendProspectToAPIInfo(state).lastProspectTime || "";

export const getScreeningInfo = state => getSendProspectToAPIInfo(state).screeningInfo;

export const getLastRoProspectTime = state =>
  getSendProspectToAPIInfo(state).lastRoProspectTime || "";
